/**
 * Registers the slice's translations into the shared "partners" and "consents"
 * namespaces.
 *
 * The foundation bundles i18n resources inline at init (see lib/i18n/i18n.ts);
 * feature slices add their own keys with addResourceBundle rather than editing
 * the shared locale JSON. deep+overwrite merges these over the placeholder
 * `partners.title`/`consents.title` seeded there. Importing this module for its
 * side effect (from index.tsx) is enough — it runs once at load.
 */
import i18n from "@/lib/i18n/i18n";

import { consentsEn, partnersEn, promoCodesEn } from "./locales/en";
import { consentsFr, partnersFr, promoCodesFr } from "./locales/fr";

i18n.addResourceBundle("fr", "translation", { partners: partnersFr }, true, true);
i18n.addResourceBundle("en", "translation", { partners: partnersEn }, true, true);
i18n.addResourceBundle("fr", "translation", { consents: consentsFr }, true, true);
i18n.addResourceBundle("en", "translation", { consents: consentsEn }, true, true);
i18n.addResourceBundle("fr", "translation", { promoCodes: promoCodesFr }, true, true);
i18n.addResourceBundle("en", "translation", { promoCodes: promoCodesEn }, true, true);
